const React = require('react')
const { useEffect, useState } = require('react')
const { useParams, useHistory } = require('react-router-dom')
const { UncontrolledTooltip } = require('reactstrap')
const { useFormatBytes } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner, CopyButton } = require('@components')

require('@styles/pages/address/statistics.address.css')

const TokenStatistics = props => {
    const { loading, data } = props
    const { address } = useParams()
    const history = useHistory()
    const { network } = useNetworkConfig()
    const formatBytes = useFormatBytes()

    const [items, setItems] = useState([{}, {}, {}])

    useEffect(() => {
        if (!data) return

        setItems([
            {
                title: 'Overview',
                content: (
                    <>
                        <div className='statistics-box-sub-title'>Max Total Supply</div>
                        <div className='statistics-box-value-small'>
                            {(data.totalSupply / 10 ** data.tokenDecimals).toLocaleString(undefined, {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: data.tokenDecimals
                            })}
                            &nbsp;
                            {data.tokenSymbol}
                        </div>
                        <br />
                        <div className='statistics-box-sub-title'>Holders</div>
                        <div className='statistics-box-value-small'>{data.totalHolders.toLocaleString()}</div>
                        <br />
                        <div className='statistics-box-sub-title'>Total Transfers</div>
                        <div
                            className='statistics-box-value-small'
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                        >
                            {data.totalTransfers.toLocaleString()}
                            <i
                                id='total-transfers-tooltip'
                                className='fas fa-circle-question'
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--grey-color)',
                                    lineHeight: 1
                                }}
                            />
                            <UncontrolledTooltip placement='top' target='total-transfers-tooltip'>
                                This count of token transfers is updated every few hours instead of in real time
                            </UncontrolledTooltip>
                        </div>
                    </>
                )
            },
            {
                title: 'Other Info',
                content: (
                    <>
                        <div className='statistics-box-sub-title'>
                            Token Contract {data.tokenDecimals && `(with ${data.tokenDecimals} decimals)`}
                        </div>
                        <div className='statistics-box-value-small'>
                            <i
                                className='fas fa-file-alt'
                                style={{
                                    fontSize: '14px',
                                    color: 'var(--grey-color)'
                                }}
                            />
                            &nbsp;
                            <span
                                className={`${network.name}-text-color cursor-pointer`}
                                onClick={() => history.push(`/${network.name}/address/${address}`)}
                            >
                                {formatBytes(address, 42, 20, 0)}
                            </span>
                            <CopyButton id={`copy-token-contract-${address}`} data={address} text={'Copy address'} />
                        </div>
                    </>
                )
            }
        ])
    }, [data])

    return (
        <div className='statistics-boxes'>
            {items.map((item, index) => (
                <div key={index} className='statistics-box'>
                    {loading ? (
                        <div className='d-flex justify-content-center align-items-center' style={{ height: '210px' }}>
                            <LoadingSpinner />
                        </div>
                    ) : (
                        <>
                            <div className='statistics-box-title'>{item.title}</div>
                            <br />
                            {item.content}
                        </>
                    )}
                </div>
            ))}
        </div>
    )
}

module.exports = { TokenStatistics }
